import type { FunctionDirective } from 'vue'
import { vTooltip } from 'floating-vue'

function isOverflowing (el: HTMLElement) {
  return el.offsetWidth < el.scrollWidth
}

const bind: FunctionDirective<any, any> = (el, { value, modifiers }) => {
  if (isOverflowing(el)) {
    // Use the HTML content of the element as the content of the tooltip.
    value = { content: el.innerHTML, html: true, ...value }
    vTooltip.updated(el, { value, modifiers })
  }
}

// v-truncate: Displays a tooltip with the content of the element, only if the
// content is overflowing (usually being ellipsized).
export default {
  beforeMount (el: HTMLElement) {
    el.classList.add('truncate')
  },
  mounted: bind,
  updated: bind,
  beforeUnmount: vTooltip.beforeUnmount,
}
